var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 161,
    viewBox: "0 0 343 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M271.179 100.37V101.21H278.496L279.2 97.9902L271.179 100.37Z",
    fill: "#242D3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M318.207 108.83L319.399 72.5884C319.43 71.6378 319.298 70.6889 319.008 69.783L316.121 60.761C313.918 53.878 307.52 49.2075 300.293 49.2075H290.118L278.476 102.095L270.242 102.095V112.019L283.656 160.999H290.119L290.119 161H297.554L311.185 117.525H314.535C314.733 117.525 314.888 117.356 314.872 117.158L314.125 108.245L318.207 108.83Z",
    fill: "url(#paint0_linear_168_64351)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M310.786 36.9361C310.148 42.847 304.85 47.1201 298.953 46.4803C293.056 45.8405 288.793 40.5301 289.432 34.6192C290.07 28.7083 295.368 24.4352 301.265 25.075C307.162 25.7148 311.425 31.0252 310.786 36.9361Z",
    fill: "#242D3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M317.537 43.866C320.268 48.1021 317.431 54.8159 317.431 54.8159C317.431 54.8159 310.166 54.6614 307.436 50.4252C304.705 46.189 307.543 39.4753 307.543 39.4753C307.543 39.4753 314.807 39.6298 317.537 43.866Z",
    fill: "#242D3C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M325.519 57.2165C328.249 61.4527 325.412 68.1665 325.412 68.1665C325.412 68.1665 318.148 68.012 315.417 63.7758C312.687 59.5396 315.524 52.8259 315.524 52.8259C315.524 52.8259 322.788 52.9803 325.519 57.2165Z",
    fill: "#242D3C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M326.462 67.4253H305.478C296.977 67.4253 289.847 73.8414 288.952 82.2956L285.567 114.304C285.333 116.516 283.467 118.195 281.243 118.195C278.841 118.195 276.894 120.142 276.894 122.543V123.736L328.114 123.736L326.462 67.4253Z",
    fill: "#333E4D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.223 105.998L261.776 100.8C266.58 95.3156 267.878 87.5906 265.131 80.8377L256.477 59.5632C253.93 53.3017 247.843 49.207 241.083 49.207H238.863C232.002 49.207 225.846 53.4238 223.367 59.8217L214.903 81.6686C212.455 87.9866 213.505 95.1259 217.668 100.472L219.179 102.413L218.805 102.415L218.806 102.416H214.332V119.222L224.872 160.999H232.536L232.381 109.424L238.447 112.556L236.051 160.999H243.716L257.929 117.525L257.223 105.998Z",
    fill: "url(#paint1_linear_168_64351)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M250.758 33.8008C250.758 39.7675 246.03 44.6045 240.196 44.6045C234.363 44.6045 229.634 39.7675 229.634 33.8008C229.634 27.8341 234.363 22.9971 240.196 22.9971C246.03 22.9971 250.758 27.8341 250.758 33.8008Z",
    fill: "#242D3C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M258.247 81.9855C257.259 73.6188 250.168 67.3145 241.743 67.3145H239.077C230.565 67.3145 223.429 73.7459 222.548 82.212L218.24 123.591L263.155 123.591L258.247 81.9855Z",
    fill: "#333E4D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M227.916 52.8752L228.043 36.8105H251.927V52.926C251.927 56.4741 249.05 59.3504 245.502 59.3504H234.341C230.773 59.3504 227.888 56.4431 227.916 52.8752Z",
    fill: "#242D3C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.3 102.205L199.143 97.8181C202.345 94.1621 203.211 89.0121 201.379 84.5102L191.231 59.5637C188.684 53.3022 182.598 49.2075 175.838 49.2075H173.618C166.756 49.2075 160.6 53.4243 158.122 59.8222L148.342 85.0641C146.71 89.2761 147.41 94.0357 150.185 97.5997L155.525 104.457L154.784 112.142L166.76 161H174.425L174.424 160.919L174.429 161H182.094L193.591 117.525L195.575 102.205H195.3Z",
    fill: "url(#paint2_linear_168_64351)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M167.976 19.388C165.757 16.4696 167.834 12.2641 171.492 12.2698L177.952 12.2799C181.632 12.2857 183.69 16.5419 181.417 19.4465L178.145 23.6292C176.362 25.9082 172.915 25.8843 171.164 23.5809L167.976 19.388Z",
    fill: "#242D3C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M184.264 33.8017C184.264 39.7685 179.414 44.6055 173.431 44.6055C167.448 44.6055 162.598 39.7685 162.598 33.8017C162.598 27.835 167.448 22.998 173.431 22.998C179.414 22.998 184.264 27.835 184.264 33.8017Z",
    fill: "#242D3C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M157.567 81.9175C158.586 73.581 165.664 67.3149 174.062 67.3149H177.406C185.804 67.3149 192.883 73.581 193.901 81.9175L198.994 123.592L152.475 123.592L157.567 81.9175Z",
    fill: "#333E4D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5642 106.465L85.1172 98.4367C81.6309 93.2985 80.8336 86.7953 82.9756 80.9671L90.6471 60.0931C93.0505 53.5536 99.2781 49.2075 106.245 49.2075H108.048C114.91 49.2075 121.065 53.4243 123.544 59.8221L132.008 81.6691C134.456 87.9871 133.406 95.1264 129.244 100.473L127.73 102.416L127.747 102.416H133.537V112.02L133.856 161H126.191L112.784 112.142L112.637 110.36L110.385 111.54L107.671 161H100.006L90.5639 115.702L90.5642 106.465Z",
    fill: "url(#paint3_linear_168_64351)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7681 33.8013C96.7681 39.768 101.376 44.605 107.059 44.605C112.743 44.605 117.351 39.768 117.351 33.8013C117.351 27.8345 112.743 22.9976 107.059 22.9976C101.376 22.9976 96.7681 27.8345 96.7681 33.8013Z",
    fill: "#242D3C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5899 81.917C89.6086 73.5805 96.687 67.3145 105.085 67.3145H109.026C117.515 67.3145 124.639 73.7117 125.549 82.1512L130.017 123.591L83.4976 123.591L88.5899 81.917Z",
    fill: "#333E4D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2991 108.828L21.1075 72.5865C21.0763 71.6358 21.2085 70.6869 21.4983 69.781L24.3853 60.759C26.5879 53.876 32.9862 49.2056 40.2129 49.2056H50.3879L62.7914 102.093L70.2666 102.093L70.2152 112.14L56.9971 160.997H50.3876L50.3875 160.998H42.9523L29.3214 117.523H25.9717C25.7737 117.523 25.618 117.354 25.6345 117.156L26.3818 108.243L22.2991 108.828Z",
    fill: "url(#paint4_linear_168_64351)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9146 35.9576C28.9146 41.903 33.723 46.7228 39.6543 46.7228C45.5857 46.7228 50.394 41.903 50.394 35.9576C50.394 30.0121 45.5857 25.1924 39.6543 25.1924C33.723 25.1924 28.9146 30.0121 28.9146 35.9576Z",
    fill: "#242D3C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0385 67.4233H35.022C43.5233 67.4233 50.6538 73.8394 51.548 82.2936L54.9335 114.302C55.1675 116.514 57.0333 118.193 59.2579 118.193C61.6595 118.193 63.6064 120.14 63.6064 122.542V123.734L12.3862 123.734L14.0385 67.4233Z",
    fill: "#333E4D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0415 94.771L62.6205 101.621H67.1822L70.8666 104.431L72.2702 97.7568L61.0415 94.771Z",
    fill: "#242D3C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1348 42.2078C36.1548 43.7719 34.4941 49.3988 31.8919 52.7844C29.2897 56.1701 26.7312 56.0323 24.7112 54.4682C22.6912 52.9042 21.9745 50.5062 24.5768 47.1205C27.179 43.7349 32.1147 40.6438 34.1348 42.2078Z",
    fill: "#242D3C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_168_64351",
    x1: 294.823,
    y1: 49.2075,
    x2: 294.823,
    y2: 161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96AAC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_168_64351",
    x1: 240.077,
    y1: 49.207,
    x2: 240.077,
    y2: 160.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96AAC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_168_64351",
    x1: 174.901,
    y1: 49.2075,
    x2: 174.901,
    y2: 161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96AAC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_168_64351",
    x1: 107.824,
    y1: 49.2075,
    x2: 107.824,
    y2: 161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96AAC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_168_64351",
    x1: 45.6848,
    y1: 49.2056,
    x2: 45.6848,
    y2: 160.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96AAC5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDashboard);
export default __webpack_public_path__ + "static/media/emptyDashboard.4da987cefe73ee7717377d8332f99e2a.svg";
export { ForwardRef as ReactComponent };